/**
 * ===============================
 * AUTH API (PRODUCTION READY)
 * ===============================
 */

import api from "./api";
import { AuthStore } from "../auth/authStore";

export const AuthAPI = {
  /* ==========================
   * LOGIN
   * ========================== */
  async login(email, password) {
    if (!email || !password) {
      throw new Error("Email dan password wajib diisi");
    }

    try {
      const res = await api.post("/api/auth/login", {
        email,
        password,
      });

      const { token, user } = res.data || {};

      if (!token) {
        throw new Error("Invalid login response");
      }

      // 🔐 persist auth
      AuthStore.setToken(token);

      if (user) {
        AuthStore.setUser(user);
      }

      return {
        token,
        user,
      };
    } catch (err) {
      throw normalizeAuthError(err);
    }
  },

  /* ==========================
   * LOGOUT
   * ========================== */
  logout({ redirect = true } = {}) {
    AuthStore.logout({ redirect });
  },

  /* ==========================
   * ME (OPTIONAL / FUTURE)
   * ========================== */
  async me() {
    try {
      const res = await api.get("/api/auth/me");
      return res.data;
    } catch (err) {
      throw normalizeAuthError(err);
    }
  },
};

/* ==========================
 * ERROR NORMALIZER
 * ========================== */
function normalizeAuthError(err) {
  if (err.response) {
    return new Error(
      err.response.data?.message ||
        `Auth error (${err.response.status})`
    );
  }

  if (err.request) {
    return new Error("Server tidak dapat dihubungi");
  }

  return new Error(err.message || "Auth error");
}
